import { useState } from "react";
import useNetworkHeaders from "../../hooks/useNetworkHeaders";
import { postCrmSearchExport, PostCrmSearchExportParamsType } from "../queries/postCrmSearchExport";
import { useToasts } from "react-toast-notifications";
import { useMutation } from "react-query";
import extractErrorInfo from "../../utils/extractErrorInfo";
import { useParams } from "react-router-dom";

export function useCrmSearchExport() {
  const headers = useNetworkHeaders();
  const { site } = useParams<{ site: string }>();
  const [isCrmSearchExportLoading, setIsCrmSearchExportLoading] = useState(false);
  const { addToast } = useToasts();
  const [crmSearchExportMutation] = useMutation(
    (body: PostCrmSearchExportParamsType) => {
      setIsCrmSearchExportLoading(true);
      return postCrmSearchExport(headers)(body);
    },
    {
      onSuccess: ({ backgroundJobId }) => {
        addToast("CRM search export initiated successfully", {
          appearance: "success",
          autoDismiss: true,
        });
        //TODO: change url when new crm list is
        window.open(`/${site}/crm/demo/export/${backgroundJobId}`, "_blank");
      },
      onError: (error) => {
        const { title, subHeader, message } = extractErrorInfo(error);
        const errorMessage = `${title} ${subHeader} ${message}`;
        addToast(errorMessage, {
          appearance: "error",
          autoDismiss: true,
        });
      },
      onSettled() {
        setIsCrmSearchExportLoading(false);
      },
    },
  );
  return {
    isCrmSearchExportLoading,
    crmSearchExportMutation,
  };
}
